/**
 * 任务中心
 * @returns
 */
import {
  Box,
  Flex,
  Text,
  Image,
  Divider,
  Center,
  Button,
  SimpleGrid,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Task } from "@/types/task";
import IntegralTaskItem from "@/components/integralComponent/intergralTaskItem";
import taskBannerBg from "@/assets/images/task_bg.png";
import Integral1 from "@/assets/images/integral_img1.png";
import Integral2 from "@/assets/images/integral_img2.png";
import LockImg from "@/assets/images/tasklock.png";
import taskImg1 from "@/assets/images/task_img1.png";
import taskImg2 from "@/assets/images/task_img2.png";
import taskImg3 from "@/assets/images/task_img3.png";
import taskImg4 from "@/assets/images/task_img4.png";
import Calendar from "@/components/signin";
import { useSelector, useDispatch } from "react-redux";
import { updateUser, selectUser } from "@/reducer/userslice";
import { useGetTasksQuery } from "@/services/api/endpoints/task";

const TaskCenter = () => {
  const user = useSelector(selectUser);

  const columns = useBreakpointValue({
    base: 1,
    sm: 1,
    md: 1,
    lg: 2,
    xl: 3,
  });

  const { data: newbieTasks } = useGetTasksQuery({task_type: "once", user_id:user.id});
  const { data: dailyTasks} = useGetTasksQuery({task_type: "daily", user_id:user.id});

  // const newbieTasks: Task[] = [
  //   {
  //     id: "1",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "注册",
  //     task_type: "",
  //     task_reward: 10,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "2",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "3",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "4",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "5",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "6",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  // ];

  // const dailyTasks: Task[] = [
  //   {
  //     id: "1",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "2",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "3",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "4",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "5",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  //   {
  //     id: "6",
  //     create_at: 0,
  //     update_at: 0,
  //     task_name: "完成一次生图任务",
  //     task_type: "",
  //     task_reward: 50,
  //     router: "",
  //     task_order: 1,
  //   },
  // ];

  return (
    <Box overflow={"hidden"}>
      <Box width="80%" m="0 auto">
        <Box
          mt="40px"
          mb="20px"
          color="#27314D"
          fontWeight="bold"
          fontSize="24px"
        >
          任务中心
        </Box>
        <Box
          h="149px"
          position={"relative"}
          bg={`url('${taskBannerBg}')`}
          backgroundSize="cover"
          backgroundPosition="top center"
          bgRepeat={"no-repeat"}
        ></Box>

        <Box mt="40px" mb="48px">
          <SimpleGrid columns={columns} gap={"30px"}>
            {/* 新手任务 */}
            <Box bg="rgba(238, 241, 247, 0.5)" border={"1px solid #DCE0EB"}>
              <Box
                bg={`url('${taskImg1}')`}
                minH="61px"
                backgroundPosition="top right"
                bgRepeat={"no-repeat"}
                p="20px"
              >
                <Flex alignItems={"center"}>
                  <Box
                    mr="20px"
                    fontSize={"18px"}
                    fontWeight="bold"
                    color={"#27314D"}
                  >
                    新手任务
                  </Box>
                  <Text mr="30px" fontSize={"12px"} color={"#8E94A9"}>
                    6/20
                  </Text>
                  <Button
                    fontSize={"18px"}
                    fontWeight="normal"
                    color={"#8E94A9"}
                    bg="none"
                    _hover={{ bg: "none" }}
                  >
                    进阶任务 <Image src={LockImg} />
                  </Button>
                </Flex>
              </Box>

              {newbieTasks && newbieTasks.map((task) => (
                <Box key={task.id}>
                  <IntegralTaskItem task={task} isCompleted={false} />
                </Box>
              ))}
            </Box>

            {/* 日常任务 */}
            <Box bg="rgba(238, 241, 247, 0.5)" border={"1px solid #DCE0EB"}>
              <Box
                bg={`url('${taskImg2}')`}
                minH="61px"
                backgroundPosition="top right"
                bgRepeat={"no-repeat"}
                p="20px"
              >
                <Flex alignItems={"center"}>
                  <Box
                    mr="20px"
                    fontSize={"18px"}
                    fontWeight="bold"
                    color={"#27314D"}
                  >
                    日常任务
                  </Box>
                  <Text fontSize={"12px"} color={"#8E94A9"}>
                    6/20
                  </Text>
                </Flex>
              </Box>

              {dailyTasks && dailyTasks.map((task) => (
                <Box key={task.id}>
                  <IntegralTaskItem task={task} isCompleted={false} />
                </Box>
              ))}
            </Box>

            {/* 每日签到 */}
            <Box bg="rgba(238, 241, 247, 0.5)" border={"1px solid #DCE0EB"}>
              <Box
                bg={`url('${taskImg3}')`}
                minH="61px"
                backgroundPosition="top right"
                bgRepeat={"no-repeat"}
                p="20px"
              >
                <Flex alignItems={"center"}>
                  <Box
                    mr="20px"
                    fontSize={"18px"}
                    fontWeight="bold"
                    color={"#27314D"}
                  >
                    每日签到
                  </Box>
                  <Button
                    fontSize={"18px"}
                    fontWeight="normal"
                    color={"#8E94A9"}
                    bg="none"
                    _hover={{ bg: "none" }}
                  >
                    签到规则 <Image src={taskImg4} />
                  </Button>
                </Flex>
              </Box>
              <Box ml="20px" mr="20px">
                <Calendar />
              </Box>
            </Box>
          </SimpleGrid>
        </Box>
      </Box>
    </Box>
  );
};

export default TaskCenter;
